// Copyright (c) Docugami, Inc. All rights reserved.

import React, { useEffect, useRef } from 'react';
import { PrimaryButton } from "@fluentui/react";
import { TextField, Checkbox } from "@fluentui/react";
import { DgXmlNames } from '../../../../components/doc_hosting/doc_hosts/word/v3/DgXmlNames';
import { BucketTimer } from '../../../../utils/bucketTimer';
import { DgWordCanvasProxy } from '../../../../components/doc_hosting/doc_hosts/word/v3/DgWordCanvasProxy';
import { DOMParser } from '@xmldom/xmldom'

// eslint-disable-next-line
import { bioplexDgml, bioplexWml, calebWml } from './WordDiagnosticsPaneData';

/* eslint-disable */
const Enumerable = require('../../../../utils/linq');
const Ltxml = require('../../../../utils/ltxml.js');
Ltxml.DOMParser = DOMParser

const openXml = require('../../../../utils/openxml');
const { v4: uuidv4 } = require('uuid');

const XAttribute = Ltxml.XAttribute;
const XCData = Ltxml.XCData;
const XComment = Ltxml.XComment;
const XContainer = Ltxml.XContainer;
const XDeclaration = Ltxml.XDeclaration;
const XDocument = Ltxml.XDocument;
const XElement = Ltxml.XElement;
const XName = Ltxml.XName;
const XNamespace = Ltxml.XNamespace;
const XNode = Ltxml.XNode;
const XObject = Ltxml.XObject;
const XProcessingInstruction = Ltxml.XProcessingInstruction;
const XText = Ltxml.XText;
const XEntity = Ltxml.XEntity;
const cast = Ltxml.cast;
const castInt = Ltxml.castInt;

const W = openXml.W;
const W14 = openXml.W14;
const W15 = openXml.W15;
const NN = openXml.NoNamespace;
const wNs = openXml.wNs;
/* eslint-enable */

export const WordDiagnosticsPane = (): JSX.Element =>
{
    const DgWordCanvasProxyRef = useRef<DgWordCanvasProxy>();

    // eslint-disable-next-line
    async function onButton4TestClicked()
    {
      let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
      let contains = await DgWordCanvasProxy.isChunkOnCanvas("6cecaf7292f7428588c5c6d8c403121f");
      console.log(`contains: ${contains}`)
    }

    // run once when the control is initialized
    useEffect(() => {
        // for bioplex
        let fieldSpanIdList = [
            "6cecaf7292f7428588c5c6d8c403121f",
            "c55f7f2810ed4bdcb4c0db7f90a3219a",
            "e79bb1da545f4e9eb85ec224aac61849",
        ];

        // for caleb
        // let fieldSpanIdList = [
        //     "05fec9a5581f4d4e9ee63cef5ad1fa58",
        //     "2975c138bd1e44d0874783626bee7118",
        //     "40e41a617de044b1b0735da503a73644",
        // ];

        DgWordCanvasProxyRef.current = new DgWordCanvasProxy();
        DgWordCanvasProxyRef.current.initialize(bioplexDgml, fieldSpanIdList);
        //DgWordCanvasProxyRef.current.initialize(calebDgml, fieldSpanIdList)
    }, [])

    // eslint-disable-next-line
    async function onCalebClicked()
    {
        return Word.run(async context => {
            context.document.body.insertOoxml(calebWml, Word.InsertLocation.replace);
            await context.sync().catch(console.error);
          });
    }

    // eslint-disable-next-line
    async function onBioplexClicked()
    {
        return Word.run(async context => {
            context.document.body.insertOoxml(bioplexWml, Word.InsertLocation.replace);
            await context.sync().catch(console.error);
          });
    }

    // eslint-disable-next-line
    async function onGetOoxmlClicked()
    {
        let OOXML: any;
        await Word.run(async context => {
            OOXML = context.document.body.getOoxml();
            await context.sync();
        });
        let root = XElement.parse(OOXML.value);
        console.log(root.toString());
    }

    function dgmlHandler(dgEventArgs: any)
    {
        if (dgEventArgs.IsField) {
            console.log(`Field Selection in dgEventArgs.DgmlSpanId: ${dgEventArgs.DgmlSpanId}`);
        }
        else {
            console.log(`Selection in dgEventArgs.DgmlSpanId: ${dgEventArgs.DgmlSpanId}`);
        }
    }

    // eslint-disable-next-line
    async function onCorrelateClicked()
    {
        BucketTimer.init();
        BucketTimer.bucket(1, "100-estab");

        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        DgWordCanvasProxy.onSelection.off(dgmlHandler);
        DgWordCanvasProxy.onSelection.on(dgmlHandler);
        DgWordCanvasProxy.onSelection.on((dgEventArgs: any) => {
            console.log(`TEST TASK PANE GOT SELECTION: ${dgEventArgs.SelectionLength}`);
        });
        await DgWordCanvasProxy.establishDgmlCorrelation();

        BucketTimer.bucket(1, "700-createCC");

        DgWordCanvasProxy.createContentControlsForFields();

        BucketTimer.bucket(1, "799-end");
        BucketTimer.dumpToConsole();
    }

    // eslint-disable-next-line
    async function onCreateRunLevelCC()
    {
        await Word.run(async context => {
            let paras = context.document.body.paragraphs;
            context.load(paras, 'text');
            await context.sync().catch(function (error) {
                console.log("????? got this error?????")
            });

            let para = paras.items[1];
            let rng3 = para.search("Agreement");
            context.load(rng3, 'text');
            await context.sync();

            console.log(rng3.items.length);

            console.log(rng3.items[0].text);


            let cc = rng3.items[0].insertContentControl();
            cc.tag = "1223";

            await context.sync();
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line
    async function onSetSelectionIP_1()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let preceedingSiblingId = "b6c6f80f8c1748db8285fcec4b80a443";
        await DgWordCanvasProxy.setSelectionIP(preceedingSiblingId, "", "");
        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onSetSelectionIP_2()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let followingSiblingId = "b6c6f80f8c1748db8285fcec4b80a443";
        await DgWordCanvasProxy.setSelectionIP("", followingSiblingId, "");
        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onSetSelectionIP_3()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let parentId = "7d43f14d095d40968da8a197078b7e17";
        await DgWordCanvasProxy.setSelectionIP("", "", parentId);
        console.log("done awaiting");
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line
    async function onInsertContent_1()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let bioplexXe = XElement.parse(bioplexDgml);
        let chunkToInsertSpanId = "121d103393d8495189a4e16b677b3810";
        let chunkToInsertXe = bioplexXe
            .descendants(DgXmlNames.chunk)
            .firstOrDefault((ch: any) => {
                let spanIdAtt = ch.attribute(DgXmlNames.spanId);
                if (spanIdAtt)
                {
                    return spanIdAtt.value === chunkToInsertSpanId;
                }
            });
        let chunkToInsertStr = chunkToInsertXe.toString();
        let preceedingSiblingId = "b6c6f80f8c1748db8285fcec4b80a443";
        await DgWordCanvasProxy.insertContent(preceedingSiblingId, "", "", "abc", chunkToInsertStr);
        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onInsertContent_2()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let bioplexXe = XElement.parse(bioplexDgml);
        let chunkToInsertSpanId = "121d103393d8495189a4e16b677b3810";
        let chunkToInsertXe = bioplexXe
            .descendants(DgXmlNames.chunk)
            .firstOrDefault((ch: any) => {
                let spanIdAtt = ch.attribute(DgXmlNames.spanId);
                if (spanIdAtt)
                {
                    return spanIdAtt.value === chunkToInsertSpanId;
                }
            });
        let chunkToInsertStr = chunkToInsertXe.toString();

        let followingSiblingId = "b6c6f80f8c1748db8285fcec4b80a443";
        await DgWordCanvasProxy.insertContent("", followingSiblingId, "", "abc", chunkToInsertStr);
        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onInsertContent_3()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let bioplexXe = XElement.parse(bioplexDgml);
        let chunkToInsertSpanId = "121d103393d8495189a4e16b677b3810";
        let chunkToInsertXe = bioplexXe
            .descendants(DgXmlNames.chunk)
            .firstOrDefault((ch: any) => {
                let spanIdAtt = ch.attribute(DgXmlNames.spanId);
                if (spanIdAtt)
                {
                    return spanIdAtt.value === chunkToInsertSpanId;
                }
            });
        let chunkToInsertStr = chunkToInsertXe.toString();

        let parentId = "7d43f14d095d40968da8a197078b7e17";
        await DgWordCanvasProxy.insertContent("", "", parentId, "abc", chunkToInsertStr);
        console.log("done awaiting");
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line
    async function onReplaceContent()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let bioplexXe = XElement.parse(bioplexDgml);
        let chunkToInsertSpanId = "121d103393d8495189a4e16b677b3810";
        let chunkToInsertXe = bioplexXe
            .descendants(DgXmlNames.chunk)
            .firstOrDefault((ch: any) => {
                let spanIdAtt = ch.attribute(DgXmlNames.spanId);
                if (spanIdAtt)
                {
                    return spanIdAtt.value === chunkToInsertSpanId;
                }
            });
        let chunkToInsertStr = chunkToInsertXe.toString();

        let spanIdToReplace = "b6c6f80f8c1748db8285fcec4b80a443";
        await DgWordCanvasProxy.replaceContent(spanIdToReplace, chunkToInsertStr);
        console.log("done awaiting");
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////

    // eslint-disable-next-line
    async function onDeleteContent()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let spanIdToDelete = "b6c6f80f8c1748db8285fcec4b80a443";
        await DgWordCanvasProxy.deleteContent(spanIdToDelete);
        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onInsertContent_4()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;

        // let bioplexXe = XElement.parse(bioplexDgml);
        // let chunkToInsertSpanId = "121d103393d8495189a4e16b677b3810";
        // let chunkToInsertXe = bioplexXe
        //     .descendants(DgXmlNames.chunk)
        //     .firstOrDefault((ch: any) => {
        //         let spanIdAtt = ch.attribute(DgXmlNames.spanId);
        //         if (spanIdAtt)
        //         {
        //             return spanIdAtt.value === chunkToInsertSpanId;
        //         }
        //     });
        // let code = chunkToInsertXe.toString();

        const textFieldElement = document.getElementById("outlined-multiline-flexible");
        let code = "";
        if (!!textFieldElement)
        {
            //code = textFieldElement.value;
        }

        let preceedingSiblingId = "b6c6f80f8c1748db8285fcec4b80a443";

        await DgWordCanvasProxy.insertContent(
          preceedingSiblingId, // precedingSiblingId
          "",                  // followingSiblingId
          "",                  // parentId
          "cocobabe",          // chunkSuggestionId
          code);

        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onInsertContent_5()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;

        const textFieldElement = document.getElementById("outlined-multiline-flexible");
        let code = "";
        if (!!textFieldElement)
        {
            //code = textFieldElement.value;
        }

console.log(code);

        await DgWordCanvasProxy.insertContentAtSelection(code);
        console.log("done awaiting");
    }

    // eslint-disable-next-line
    async function onGetSelection()
    {
        let DgWordCanvasProxy: DgWordCanvasProxy = DgWordCanvasProxyRef.current as DgWordCanvasProxy;
        let sel = await DgWordCanvasProxy.getWordCanvasSelectionAsDgml();
        console.log(sel);
    }

    // eslint-disable-next-line
    async function onCodeCb(e: any)
    {
        // console.log(`The checkbox ${e.target.name} is ${e.target.checked ? "checked" : "unchecked"}`);
        setCodePerName(e.target.name);
    }

    function setCodePerName(name: string)
    {
        //  var dict: { [name: string]: string; } = {
        //     "1": "000001-dgml",
        //     "2": "000002-dgml",
        //     "3": "000003-dgml",
        //     "4": "000004-dgml",
        //     "5": "000005-dgml",
        //     "6": "000006-dgml",
        //     "7": "000007-dgml",
        //     "8": "000008-dgml",
        //     "9": "000009-dgml",
        //     "10": "000010-dgml",
        //     "11": "000011-dgml",
        //     "12": "000012-dgml",
        //     "15": "000015-dgml",
        // };

        // const key = dict[name];

        // // const code = getRegressionTestDataDgmlToWml(key);
        // const textFieldElement = document.getElementById("outlined-multiline-flexible");
        // if (!!textFieldElement)
        // {
        //     //textFieldElement.value = code;
        // }
    }

    return (
        <div style={{height: "100%", width: "100%", display: "flex", flexDirection: "column"}}>
            {
            /*
            <PrimaryButton onClick={onCalebClicked}>Caleb</PrimaryButton>
            */
            }

            <PrimaryButton onClick={onBioplexClicked}>Bioplex</PrimaryButton>
            <PrimaryButton onClick={onCorrelateClicked}>Establish Correlation</PrimaryButton>

            {
            /*
            <PrimaryButton onClick={onButton4TestClicked}>Does Span Exist</PrimaryButton>
            */
            }

            <PrimaryButton onClick={onGetOoxmlClicked}>Get OOXML</PrimaryButton>

            {/*
            <PrimaryButton onClick={onCreateRunLevelCC}>Create CC</PrimaryButton>

            <PrimaryButton onClick={onSetSelectionIP_1}>setSelectionIP Preceeding Sibling</PrimaryButton>
            <PrimaryButton onClick={onSetSelectionIP_2}>setSelectionIP Following Sibling</PrimaryButton>
            <PrimaryButton onClick={onSetSelectionIP_3}>setSelectionIP Parent setSelectionIP</PrimaryButton>

            <PrimaryButton onClick={onInsertContent_1}>insertContent Preceeding Sibling</PrimaryButton>
            <PrimaryButton onClick={onInsertContent_2}>insertContent Following Sibling</PrimaryButton>
            <PrimaryButton onClick={onInsertContent_3}>insertContent Parent</PrimaryButton>}
            */}

            <PrimaryButton onClick={onGetSelection}>getSelection</PrimaryButton>
            <PrimaryButton onClick={onInsertContent_5}>insertContent</PrimaryButton>

            {
            /*
            <PrimaryButton onClick={onReplaceContent}>Replace Content</PrimaryButton>
            <PrimaryButton onClick={onDeleteContent}>Delete Content</PrimaryButton>
            */
            }

            {
            // look at ChunkTagInputField
            }
            <TextField id="outlined-multiline-flexible" label="DGML to Insert" multiline />
            <Checkbox id="cb1" label="Paragraph" name='1' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb2" label="List no list-style-type" name='2' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb3" label="divs" name='3' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb4" label="list-style-type: decimal" name='4' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb5" label="list-style-type: upper-alpha" name='5' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb6" label="list-style-type: lower-alpha" name='6' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb7" label="list-style-type: upper-roman" name='7' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb8" label="list-style-type: lower-roman" name='8' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb9" label="Unordered list, list-style-type: circle" name='9' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb10" label="table colspan" name='10' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb11" label="table colspan and rowspan" name='11' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb12" label="table rowspan" name='12' onChange={e => onCodeCb(e)} />
            <Checkbox id="cb15" label="two para" name='15' onChange={e => onCodeCb(e)} />

        </div>
    )
}
